export default __webpack_public_path__ + "static/media/vehicle_subtier.73ee53cc.svg";